<template>
  <FormDeliveryPriceCalcItem v-model="componentValue" class="delivery-calc" />
</template>

<script>
export default {
  props: ["modelValue", "item", "typeField"],
  data: ()=>({
    componentValue: {},
  }),
  computed: {

  },
  watch: {
    modelValue: {
      handler() {
        this.componentValue=this.modelValue || {compound: null};
      }, immediate: true,
    },
    componentValue: {
      handler () {
        if (JSON.stringify(this.componentValue)!=JSON.stringify(this.modelValue))
          this.$emit("update:modelValue", this.componentValue);
      }, deep: true,
    }
  },
}
</script>
